webpackJsonp([266066846235802],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function Modal(_ref) {
	    var isOpen = _ref.isOpen,
	        children = _ref.children;
	
	    if (isOpen) {
	        return _react2.default.createElement(
	            _styles.ModalWindow,
	            null,
	            children
	        );
	    }
	    return null;
	};
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n'], ['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(13);
	
	var _Navigation = __webpack_require__(21);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Modal = __webpack_require__(197);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sticky = _styledComponents2.default.div(_templateObject);
	
	var PublicatiePage = function (_Component) {
	  _inherits(PublicatiePage, _Component);
	
	  function PublicatiePage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PublicatiePage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isOpen: false,
	      document: null,
	      title: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PublicatiePage.prototype.render = function render() {
	    var _this2 = this;
	
	    var navItems = this.props.data.allNavigationJson.edges;
	    var publicationItems = this.props.data.allPublicatiesJson.edges[0].node;
	    var subNavItems = navItems.filter(function (_ref, index) {
	      var navItem = _ref.node;
	      return index === 2;
	    });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Sticky,
	        null,
	        _react2.default.createElement(_Navigation2.default, { items: subNavItems, navType: 'sub' })
	      ),
	      publicationItems.publicaties.map(function (publicationByYear, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            _styles.PublicationYear,
	            null,
	            publicationByYear.year
	          ),
	          publicationByYear.publications.map(function (publication, index) {
	            return _react2.default.createElement(
	              _styles.SplitSectionPublication,
	              { key: index },
	              _react2.default.createElement(
	                _styles.LeftSectionPublication,
	                null,
	                _react2.default.createElement(_styles.PublicationImage, { src: publication.img, alt: '' })
	              ),
	              _react2.default.createElement(
	                _styles.RightSectionPublication,
	                null,
	                _react2.default.createElement(
	                  _styles.Title,
	                  null,
	                  publication.titel
	                ),
	                _react2.default.createElement(
	                  _styles.SubTitle,
	                  null,
	                  publication.subtitel
	                ),
	                publication.document !== '' ? _react2.default.createElement(
	                  _styles.PublicationLink,
	                  {
	                    onClick: function onClick() {
	                      return _this2.setState({
	                        isOpen: true,
	                        document: publication.document,
	                        title: publication.title
	                      });
	                    }
	                  },
	                  'Bekijk volledige publicatie'
	                ) : null,
	                publication.url !== '' ? _react2.default.createElement(
	                  _styles.PublicationExternalLink,
	                  {
	                    href: publication.url,
	                    target: '_blank'
	                  },
	                  'Bekijk online publicatie'
	                ) : null
	              )
	            );
	          })
	        );
	      }),
	      _react2.default.createElement(
	        _Modal2.default,
	        { isOpen: this.state.isOpen },
	        _react2.default.createElement(
	          _styles.PdfViewer,
	          { data: this.state.document, type: 'application/pdf' },
	          _react2.default.createElement('embed', { src: this.state.document, type: 'application/pdf' })
	        ),
	        _react2.default.createElement(
	          _styles.ButtonModal,
	          { onClick: function onClick() {
	              return _this2.setState({ isOpen: false });
	            } },
	          'X SLUIT'
	        )
	      )
	    );
	  };
	
	  return PublicatiePage;
	}(_react.Component);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = PublicatiePage;

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-nieuws-publicatie-js-25504f958bdee53057f1.js